// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assetHealthDetails__PRRRy {
  padding: 25px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: calc(100% - 55px);
}
.assetHealthDetails__PRRRy::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.assetHealthDetails__PRRRy::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.assetHealthDetails__PRRRy::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.assetHealthDetails__PRRRy::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 875px) {
  .assetHealthDetails__PRRRy {
    padding: 15px;
    row-gap: 15px;
  }
}

.assetHealthDetailsInfoBlock__loUxm {
  display: flex;
  flex-wrap: wrap;
}

.assetHealthDetailsFilters__ABEDe {
  flex: 0 0 40%;
  display: flex;
  justify-content: space-between;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  padding: 15px;
}
@media (max-width: 900px) {
  .assetHealthDetailsFilters__ABEDe {
    flex: 0 0 100%;
  }
}

.urgencyFilter__LsO6X {
  max-width: 200px;
}

.tableWrapper__SjFs7 {
  display: flex;
  justify-content: space-between;
  column-gap: 25px;
  width: 100%;
}
@media (max-width: 875px) {
  .tableWrapper__SjFs7 {
    column-gap: 15px;
  }
}

.leftBlock__U_RbM {
  flex: 0 0 calc(75% - 25px);
}
@media (max-width: 875px) {
  .leftBlock__U_RbM {
    flex: 0 0 calc(75% - 15px);
  }
}

.rightBlock__ajuEw {
  flex: 0 0 25%;
}`, "",{"version":3,"sources":["webpack://./../src/pages/AssetHealthDetails/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;AAzEF;AAoBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,kBAAA;AArBJ;AA2DE;EARF;IASI,aAAA;IACA,aAAA;EAxDF;AACF;;AA2DA;EACE,aAAA;EACA,eAAA;AAxDF;;AA2DA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,kDAAA;EACA,qDAAA;EACA,aAAA;AAxDF;AA0DE;EARF;IASI,cAAA;EAvDF;AACF;;AA0DA;EACE,gBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AAvDF;AAyDE;EANF;IAOI,gBAAA;EAtDF;AACF;;AAyDA;EACE,0BAAA;AAtDF;AAwDE;EAHF;IAII,0BAAA;EArDF;AACF;;AAwDA;EACE,aAAA;AArDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.assetHealthDetails {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  height: calc(100% - 55px);\n  @include scrollBar;\n\n  @media (max-width: 875px) {\n    padding: 15px;\n    row-gap: 15px;\n  }\n}\n\n.assetHealthDetailsInfoBlock {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.assetHealthDetailsFilters {\n  flex: 0 0 40%;\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  padding: 15px;\n\n  @media (max-width: 900px) {\n    flex: 0 0 100%;\n  }\n}\n\n.urgencyFilter {\n  max-width: 200px;\n}\n\n.tableWrapper {\n  display: flex;\n  justify-content: space-between;\n  column-gap: 25px;\n  width: 100%;\n\n  @media (max-width: 875px) {\n    column-gap: 15px;\n  }\n}\n\n.leftBlock {\n  flex: 0 0 calc(75% - 25px);\n\n  @media (max-width: 875px) {\n    flex: 0 0 calc(75% - 15px);\n  }\n}\n\n.rightBlock {\n  flex: 0 0 25%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"assetHealthDetails": `assetHealthDetails__PRRRy`,
	"assetHealthDetailsInfoBlock": `assetHealthDetailsInfoBlock__loUxm`,
	"assetHealthDetailsFilters": `assetHealthDetailsFilters__ABEDe`,
	"urgencyFilter": `urgencyFilter__LsO6X`,
	"tableWrapper": `tableWrapper__SjFs7`,
	"leftBlock": `leftBlock__U_RbM`,
	"rightBlock": `rightBlock__ajuEw`
};
module.exports = ___CSS_LOADER_EXPORT___;
